module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1);


/***/ }),
/* 1 */
/***/ (function(module, exports) {

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

// Copyright (c) 2018 Ytica.com a.s. - All Rights Reserved
// Unauthorized copying of this file, via any medium is strictly prohibited
// Proprietary and confidential
var browserEnabledKey = 'ytica-js-logger:enabled';
var browserLogLevelKey = 'ytica-js-logger:logLevel';
var lvl = {};
lvl.DEBUG = {
  value: 0,
  name: 'DEBUG'
};
lvl.INFO = {
  value: 1,
  name: 'INFO'
};
lvl.WARN = {
  value: 2,
  name: 'WARN'
};
lvl.ERROR = {
  value: 3,
  name: 'ERROR' // invoke log handler with specific level and call hooks

};

function invoke(level, msg) {
  // if browser, check for global settings
  if (this.isBrowser) {
    if (!this.isEnabled) return false;
  }

  var messages = this.options.formatter(Array.prototype.slice.call(msg), this);

  if (this.options.logHandler && this.enabledFor(level)) {
    this.options.logHandler(messages, level);
  }

  this.options.afterLog.call(this, messages, level);
} // default log handler


function logHandler(msg, level) {
  if (typeof console === "undefined") {
    return; // no console
  }

  var invokeConsoleMethod = function invokeConsoleMethod(fnc, message) {
    Function.prototype.apply.call(fnc, console, message);
  };

  var fnc = console.log;

  if (level === lvl.ERROR && console.error) {
    fnc = console.error;
  } else if (level === lvl.WARN && console.warn) {
    fnc = console.warn;
  } else if (level === lvl.INFO && console.info) {
    fnc = console.info;
  } else if (level === lvl.DEBUG && console.debug) {
    fnc = console.debug;
  }

  invokeConsoleMethod(fnc, msg);
} // default formatter


function formatter(messages, logger) {
  messages.unshift("[".concat(logger.options.name, "]"));
  return messages;
} // init browser global settings


function initBrowserGlobalSettings(_ref) {
  var enabled = _ref.enabled,
      logLevel = _ref.logLevel;

  if (!localStorage.getItem(browserEnabledKey)) {
    localStorage.setItem(browserEnabledKey, enabled);
  }
}

var JSLogger =
/*#__PURE__*/
function () {
  function JSLogger(options) {
    _classCallCheck(this, JSLogger);

    var _defaults = {
      level: lvl.INFO,
      logHandler: logHandler,
      afterLog: function afterLog() {},
      suppress: [],
      formatter: formatter
    };
    this.options = Object.assign({}, _defaults, options); // check wether we run browser or node environment

    if (this.isBrowser) {
      // if browser, set global settings
      initBrowserGlobalSettings({
        enabled: true
      });
    }
  }

  _createClass(JSLogger, [{
    key: "enabledFor",
    value: function enabledFor(lvl) {
      var defaultLevel = this.localStorageDefaultLevel || this.options.level;
      var enabled = lvl.value >= defaultLevel.value;
      var suppressed = this.options.suppress.includes(lvl);
      return enabled && !suppressed;
    }
  }, {
    key: "debug",
    value: function debug() {
      invoke.call(this, lvl.DEBUG, arguments);
    }
  }, {
    key: "info",
    value: function info() {
      invoke.call(this, lvl.INFO, arguments);
    }
  }, {
    key: "log",
    value: function log() {
      invoke.call(this, lvl.INFO, arguments);
    }
  }, {
    key: "warn",
    value: function warn() {
      invoke.call(this, lvl.WARN, arguments);
    }
  }, {
    key: "error",
    value: function error() {
      invoke.call(this, lvl.ERROR, arguments);
    }
  }, {
    key: "isEnabled",
    get: function get() {
      return JSON.parse(localStorage.getItem(browserEnabledKey));
    }
  }, {
    key: "localStorageDefaultLevel",
    get: function get() {
      var lsLevel = localStorage.getItem(browserLogLevelKey);
      return lvl[lsLevel];
    }
  }, {
    key: "isBrowser",
    get: function get() {
      return typeof window !== 'undefined';
    }
  }], [{
    key: "DEBUG",
    get: function get() {
      return lvl.DEBUG;
    }
  }, {
    key: "INFO",
    get: function get() {
      return lvl.INFO;
    }
  }, {
    key: "WARN",
    get: function get() {
      return lvl.WARN;
    }
  }, {
    key: "ERROR",
    get: function get() {
      return lvl.ERROR;
    }
  }]);

  return JSLogger;
}();

module.exports = JSLogger;

/***/ })
/******/ ]);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ytica/js-logger/dist/index.js
// module id = iy7K
// module chunks = 0